import { AlertCircle } from 'lucide-react';

/**
 * Error message component for form validation
 */
export function ErrorMessage({ error, className = '' }) {
  if (!error) return null;
  
  return (
    <div className={`flex items-center gap-1 text-sm text-red-600 mt-1 ${className}`}>
      <AlertCircle className="h-3 w-3 flex-shrink-0" />
      <span>{error}</span>
    </div>
  );
}

/**
 * Get input class based on error state
 */
export function getInputClass(error) {
  return error 
    ? 'border-red-500 focus:border-red-500 focus:ring-red-500 bg-red-50' 
    : '';
}

export default ErrorMessage;
